<template>
  <div class="content" :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.indexPadding*2)+"px"}'>
      <div class="common-items-center common-space-between">
        <div class="common-items-center">
            <InputBlock title="ParmName" >
                <el-input v-model="wordVal" :size="this.$store.state.inputSize" placeholder="请输入ParmName" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
            </InputBlock> 
            <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
            <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
        </div>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
      </div>
       <div class="warp-table">
        <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize" style="width: 100%"  row-key="id"  :height="this.$store.state.windowHeight-270">
            <el-table-column align="center" header-align="center" prop="date"    label="序号"    width="50">
              <template slot-scope="scope">{{scope.$index+1}}</template>
            </el-table-column>
            <el-table-column align="left"   header-align="left"   prop="sysName"       label="ParamName"   width="300"></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="typeName"      label="ParamValue"    ></el-table-column>
            <el-table-column align="left"   header-align="left"   prop="remarks"       label="描述"        > </el-table-column>
            <el-table-column align="left"   header-align="left"   prop="createTime"    label="创建时间"  width="200"   ></el-table-column>
            <el-table-column align="center" header-align="center" fixed="right"   label="操作"       width="100">
              <template slot-scope="scope">
                <div class="common-width common-space-around warp-btn operate">
                    <el-link :underline="false"  @click="ediBtn(scope.row)" type="primary" size="mini">编辑</el-link>
                    <el-popconfirm title="确定删除么"   @confirm="deleteBtn(scope.row)">
                       <el-link :underline="false" slot="reference" type="danger" size="mini">删除</el-link>
                    </el-popconfirm>   
                </div>
              </template>
            </el-table-column>
          </el-table>
          <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
       </div>
       <AddBlock ref="add"></AddBlock>
  </div>
</template>
<script>
import { scroll } from '@/components/component-mixin/block-scroll'
import AddBlock from './common-module/add-block-system.vue'
import {url,operate} from '@/utils/config'
import {postFun,getFun,deleteFun} from '@/utils/httpFun'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
      AddBlock:AddBlock
  },
  data:()=>({
    input:"",
    wordVal:"",
    tableData: [{}],
    current:1,
    size:10,
    total:10,
  }),
  created(){
     this.size = this.$store.state.pageSize
     this.getList()
  },
  methods:{
    //获取所有的数据
    async getList(){
      let parms = {
            param:{
              sysName:this.wordVal,
            },
            current:this.current,
            size:this.size
       }
       await postFun(operate.SYSTEMLIST,parms,res=>{
              this.tableData = res.data.records
              this.total = res.data.total
              this.size = res.data.size
              this.current = res.data.current
       })
    },
    
    //获取输入的值
    getVal(ev){
      this.wordVal =  ev.val
    },
    
    //搜索
    searchBtn(){
       this.getList()
    },

    //重置
    resetBtn(){
      this.wordVal = ""
      this.current = 1
      this.getList()
    },
    //删除
    async deleteBtn(ev){
        
        await deleteFun(operate.SYSTEMDELETE+"/"+ev.id,{},res=>{
          this.getList()
        })
    },

    //刷新
    requestBtn(){
      this.current = 1 
      this.getList() 
    },
    
    
    //新增弹窗
    addBtn(){
       this.$refs.add.showMessage("add",{});
    },
    //编辑弹窗
    ediBtn(ev){
       this.$refs.add.showMessage("eidt",ev);
    },
    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
    .content{
       box-sizing: border-box;
       padding:15px;
    }
    .warp-table{
      margin-top: 15px;
    }
    .operate{
      ::v-deep .el-button--mini{
        padding: 5px 8px;
      }
    }
</style>
